export interface Recipe {
  name: string;
  ingredients: Array<Ingredient>;
  notes?: string;
  favorites?: Array<string>;
}

export interface Ingredient {
  name: string;
  measurement?: string;
  substitution?: Ingredient;
}

export interface Measurement {
  count: number;
  unit?: string;
}

export const Recipes: Array<Recipe> = [
  {
    name: "Sidecar",
    ingredients: [
      {
        name: "cognac",
        measurement: "2 oz",
      },
      {
        name: "Cointreau",
        measurement: "1 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
    favorites: ["Ryan"],
  },
  {
    name: "Man O' War",
    ingredients: [
      {
        name: "bourbon",
        measurement: "2 oz",
        substitution: {
          name: "rye whiskey",
        },
      },
      {
        name: "Cointreau",
        measurement: "1 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "1/2 oz",
      },
      {
        name: "lemon juice",
        measurement: "1/2 oz",
      },
    ],
    favorites: ["Ryan"],
  },
  {
    name: "Last Word",
    ingredients: [
      {
        name: "gin",
        measurement: "3/4 oz",
      },
      {
        name: "Green Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Corpse Reviver No. 2",
    ingredients: [
      {
        name: "gin",
        measurement: "3/4 oz",
      },
      {
        name: "Cointreau",
        measurement: "3/4 oz",
      },
      {
        name: "Cocci Americano",
        measurement: "3/4 oz",
        substitution: {
          name: "Lillet",
        },
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
      {
        name: "absinthe rinse",
      },
    ],
  },
  {
    name: "Pegu Club",
    ingredients: [
      {
        name: "gin",
        measurement: "2 oz",
      },
      {
        name: "Cointreau",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "3/4 oz",
      },
      {
        name: "Angostura bitters",
        measurement: "1 dash",
      },
      {
        name: "orange bitters",
        measurement: "1 dash",
      },
    ],
  },
  {
    name: "Bees Knees",
    ingredients: [
      {
        name: "gin",
        measurement: "2 oz",
      },
      {
        name: "honey syrup",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
    favorites: ["Val"],
  },
  {
    name: "Old Pal",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "1 1/2 oz",
      },
      {
        name: "Campari",
        measurement: "3/4 oz",
        substitution: {
          name: "other amaro",
        },
      },
      {
        name: "dry vermouth",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Gold Rush",
    ingredients: [
      {
        name: "bourbon",
        measurement: "2 oz",
      },
      {
        name: "lemon juice",
        measurement: "1 oz",
      },
      {
        name: "honey syrup",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Amaro Sour",
    ingredients: [
      {
        name: "amaro",
        measurement: "1 1/2 oz",
      },
      {
        name: "bourbon",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "1 oz",
      },
      {
        name: "simple syrup",
        measurement: "1/4 oz",
      },
      {
        name: "egg white",
        measurement: "1",
      },
    ],
  },
  {
    name: "Manhattan",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "2 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "1 oz",
      },
      {
        name: "Angostura bitters",
        measurement: "4 dashes",
      },
    ],
  },
  {
    name: "Paper Plane",
    ingredients: [
      {
        name: "bourbon",
        measurement: "3/4 oz",
      },
      {
        name: "Amaro Nonino",
        measurement: "3/4 oz",
        substitution: {
          name: "other amaro",
        },
      },
      {
        name: "Aperol",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
    favorites: ["Ryan", "Val"],
  },
  {
    name: "Hidden Fortress",
    ingredients: [
      {
        name: "Roku gin",
        measurement: "1 oz",
      },
      {
        name: "yuzu shochu",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "1/4 oz",
      },
      {
        name: "simple syrup",
        measurement: "3/4 oz",
      },
      {
        name: "olive oil",
        measurement: "1/2 oz",
      },
      {
        name: "egg white",
        measurement: "1",
      },
      {
        name: "absinthe rinse",
      },
    ],
    favorites: ["Val"],
    notes: "Dry shake 15 seconds, then shake wet for an additional 15 seconds.",
  },
  {
    name: "Final Ward",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "3/4 oz",
      },
      {
        name: "Green Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Aperol Paloma",
    ingredients: [
      {
        name: "blanco tequila",
        measurement: "1 1/2 oz",
      },
      {
        name: "grapefruit juice",
        measurement: "1 1/2 oz",
      },
      {
        name: "Cointreau",
        measurement: "1 oz",
      },
      {
        name: "Aperol",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "1/2 oz",
      },
    ],
    favorites: ["Ryan", "Val"],
  },
  {
    name: "Negroni",
    ingredients: [
      {
        name: "gin",
        measurement: "1 oz",
      },
      {
        name: "Campari",
        measurement: "1 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "1 oz",
      },
    ],
  },
  {
    name: "Sazerac",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "3 oz",
      },
      {
        name: "rich simple syrup",
        measurement: "1/4 oz",
      },
      {
        name: "Peychaud’s bitters",
        measurement: "3 dashes",
      },
      {
        name: "absinthe rinse",
      },
    ],
  },
  {
    name: "Greenpoint",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "2 oz",
      },
      {
        name: "Yellow Chartreuse",
        measurement: "1/2 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "1/2 oz",
      },
      {
        name: "Angostura bitters",
        measurement: "1 dash",
      },
      {
        name: "orange bitters",
        measurement: "1 dash",
      },
    ],
    tastingNotes: "Syrupy and almost saccharine.",
  },
  {
    name: "Monte Cassino",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "3/4 oz",
      },
      {
        name: "Benedictine",
        measurement: "3/4 oz",
      },
      {
        name: "Yellow Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Bijou",
    ingredients: [
      {
        name: "gin",
        measurement: "1 1/2 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "1 oz",
      },
      {
        name: "Green Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "orange bitters",
        measurement: "2 dashes",
      },
    ],
  },
  {
    name: "Amaro Bees Knees",
    ingredients: [
      {
        name: "gin",
        measurement: "1 oz",
      },
      {
        name: "Amaro Nonino",
        measurement: "1 oz",
        substitution: {
          name: "other amaro",
        },
      },
      {
        name: "lemon juice",
        measurement: "1 oz",
      },
      {
        name: "honey syrup",
        measurement: "3/4 oz",
      },
    ],
    favorites: ["Val"],
  },
  {
    name: "Vieux Carré",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "1 oz",
      },
      {
        name: "cognac",
        measurement: "1 oz",
      },
      {
        name: "sweet vermouth",
        measurement: "3/4 oz",
      },
      {
        name: "Benedictine",
        measurement: "3/4 oz",
      },
      {
        name: "Angostura bitters",
        measurement: "1 dash",
      },
      {
        name: "Peychaud's bitters",
        measurement: "1 dash",
      },
    ],
  },
  {
    name: "Brunch Box",
    ingredients: [
      {
        name: "Amaro Montenegro",
        measurement: "1 oz",
      },
      {
        name: "lager beer",
        measurement: "5 oz",
      },
      {
        name: "grapefruit juice",
        measurement: "1 oz",
      },
    ],
    favorites: ["Ryan", "Val"],
  },
  {
    name: "Cynara",
    ingredients: [
      {
        name: "bourbon",
        measurement: "1 1/2 oz",
      },
      {
        name: "Cynar",
        measurement: "1/2 oz",
      },
      {
        name: "Aperol",
        measurement: "1/2 oz",
      },
      {
        name: "Hella bitters ice cube",
      },
    ],
  },
  {
    name: "Part Time Lover",
    ingredients: [
      {
        name: "tequila (reposado, preferred)",
        measurement: "1 1/2 oz",
      },
      {
        name: "Aperol",
        measurement: "1/2 oz",
      },
      {
        name: "St. Germain",
        measurement: "1/2 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
      {
        name: "Angostura bitters",
        measurement: "2-3 dashes",
      },
    ],
  },
  {
    name: "Light & Day",
    ingredients: [
      {
        name: "gin",
        measurement: "2 oz",
      },
      {
        name: "Yellow Chartreuse",
        measurement: "1/2 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "1/4 oz",
      },
      {
        name: "orange juice",
        measurement: "1/4 oz",
      },
      {
        name: "Peychaud’s bitters",
        measurement: "4 dashes",
      },
    ],
  },
  {
    name: "King's Ransom",
    ingredients: [
      {
        name: "mezcal",
        measurement: "1 oz",
      },
      {
        name: "Green Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "St. Germain",
        measurement: "3/4 oz",
      },
      {
        name: "lemon juice",
        measurement: "3/4 oz",
      },
    ],
    favorites: ["Ryan"],
  },
  {
    name: "Rising Sun",
    ingredients: [
      {
        name: "mezcal",
        measurement: "1 1/2 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "1/2 oz",
      },
      {
        name: "grapefruit juice",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "1/2 oz",
      },
    ],
  },
  {
    name: "Witty Comeback",
    ingredients: [
      {
        name: "rye whiskey",
        measurement: "2 oz",
      },
      {
        name: "Amaro Averna",
        measurement: "1/2 oz",
      },
      {
        name: "ginger simple syrup",
        measurement: "1/2 oz",
      },
      {
        name: "lemon juice",
        measurement: "1/2 oz",
      },
    ],
  },
  {
    name: "El Chingon",
    ingredients: [
      {
        name: "tequila (reposado, preferred)",
        measurement: "2 oz",
      },
      {
        name: "Benedictine",
        measurement: "1/4 oz",
      },
      {
        name: "orange juice",
        measurement: "1/2 oz",
      },
      {
        name: "lime juice",
        measurement: "1/2 oz",
      },
      {
        name: "orgeat syrup",
        measurement: "1/2 oz",
      },
    ],
  },
  {
    name: "Mig Royale",
    ingredients: [
      {
        name: "gin",
        measurement: "1 oz",
      },
      {
        name: "Cointreau",
        measurement: "3/4 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "1/2 oz",
      },
      {
        name: "lemon juice",
        measurement: "1/2 oz",
      },
      {
        name: "champagne",
        measurement: "to fill",
      },
    ],
    favorites: ["Ryan", "Val"],
  },
  {
    name: "Julien Sorel",
    ingredients: [
      {
        name: "cognac",
        measurement: "1/2 oz",
      },
      {
        name: "Green Chartreuse",
        measurement: "1/2 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "1/2 oz",
      },
      {
        name: "lemon juice",
        measurement: "1/2 oz",
      },
      {
        name: "champagne",
        measurement: "to fill",
      },
    ],
  },
  {
    name: "Naked & Famous",
    ingredients: [
      {
        name: "mezcal",
        measurement: "3/4 oz",
      },
      {
        name: "Aperol",
        measurement: "3/4 oz",
      },
      {
        name: "Yellow Chartreuse",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "French 75",
    ingredients: [
      {
        name: "gin",
        measurement: "1 oz",
      },
      {
        name: "lemon juice",
        measurement: "1/2 oz",
      },
      {
        name: "simple syrup",
        measurement: "1/2 oz",
      },
      {
        name: "champagne",
        measurement: "3 oz",
      },
    ],
  },
  {
    name: "Division Bell",
    ingredients: [
      {
        name: "mezcal",
        measurement: "3/4 oz",
      },
      {
        name: "Aperol",
        measurement: "3/4 oz",
      },
      {
        name: "maraschino liqueur",
        measurement: "3/4 oz",
      },
      {
        name: "lime juice",
        measurement: "3/4 oz",
      },
    ],
  },
  {
    name: "Cable Car",
    ingredients: [
      {
        name: "spiced rum",
        measurement: "1 1/2 oz",
      },
      {
        name: "dry curaçao",
        measurement: "3/4 oz",
        substitution: {
          name: "Cointreau",
        },
      },
      {
        name: "lemon juice",
        measurement: "1 oz",
      },
      {
        name: "simple syrup",
        measurement: "1/2 oz",
      },
    ],
  },
].sort((a, b) => a.name.localeCompare(b.name));
